<template>
  <v-dialog
    v-model="dialog"
    persistent 
    max-width="1250px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        block
        color="success"
        v-on="on"
      >
        Add Job Requirement
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="green"
      title="Job Requirement"
      text="Create Job Requirement"
      class="mb-0"
    > 
      <form
        v-if="!loading"
        class="overflow"
        data-simplebar
      >
        <v-container>
          <v-row>
            <v-col cols="10">
              <v-autocomplete
                v-model="selectedRank"
                :items="validGrades"
                label="Rank"
                placeholder="Rank Assignment"
                item-text="pivot.name"
                item-value="pivot.id"
                hide-no-data
                hide-selected
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                  >
                    <v-avatar
                      tile
                      left
                    >
                      <img :src="data.item.image_url">
                    </v-avatar>
                    {{ data.item.pivot.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-avatar 
                      size="40px" 
                      tile
                    >
                      <img :src="data.item.image_url">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.pivot.name" />
                      <v-list-item-subtitle> {{ `Rank ${data.item.value}` }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="2">
              <v-btn
                class="mx-2 font-weight-light"
                color="info"          
                @click="copyRequirements"
              >
                Copy Requirements
              </v-btn>
            </v-col>
          </v-row>
          <v-row>            
            <v-col cols="12">
              <v-card>
                <v-card-actions>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search by description"
                    single-line
                    hide-details
                  />
                  <v-spacer />
                  <v-btn
                    class="mx-2 font-weight-light"
                    color="primary"          
                    @click="resetSelected"
                  >
                    Reset
                  </v-btn>
                </v-card-actions>
                <v-card-actions>
                  <v-autocomplete
                    :items="tags"    
                    :loading="loadingTags"     
                    placeholder="Filter by tags"
                    item-text="name"
                    item-value="id"
                    color="primary"
                    hide-no-data
                    hide-selected
                    clearable
                    multiple
                    chips
                    deletable-chips
                    @change="filter"
                  />
                </v-card-actions>
                <v-data-table
                  v-model="selectedJobDescription"
                  :headers="headers"
                  :items="filteredJobDescriptions"
                  :search="search"
                  show-select
                  disable-pagination
                  hide-default-footer
                  fixed-header
                  height="450px"
                >
                  <template v-slot:item="props">
                    <tr>
                      <td>
                        <v-simple-checkbox
                          color="primary"
                          :value="props.isSelected"
                          @input="props.select($event)"
                        />
                      </td>
                      <td class="py-2">
                        <p>{{ props.item.value }}</p>
                        <div>
                          <v-chip 
                            v-for="tag in props.item.tags" 
                            :key="tag.id"
                            color="primary"
                            class="mx-1"
                            label
                            outlined
                            small
                          >
                            {{ tag.name }}
                          </v-chip>
                        </div>
                      </td>
                      <td>                   
                        <v-row                            
                          class="horizontal-scroll-xl"
                        >
                          <span 
                            v-for="skill in props.item.skills" 
                            :key="skill.id"
                            class="pa-2 text-center"
                          >
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-avatar
                                  size="30"
                                  tile
                                  v-on="on" 
                                >
                                  <img
                                    :src="skill.image_url"
                                    alt="skill logo"
                                  >
                                </v-avatar>
                              </template>
                              {{ skill.name }}
                            </v-tooltip>
                            <v-menu
                              v-if="props.isSelected"
                              :close-on-content-click="false"
                              :nudge-top="60"
                              max-width="550px"
                              max-height="550px"
                              open-on-hover
                              top
                            >
                              <template v-slot:activator="{ on }">
                                <div v-on="on">
                                  <v-rating      
                                    v-model="skill.rating"
                                    :length="skill.levels.length"
                                    hover                                
                                    size="15px"                                  
                                  />
                                </div>
                              </template>

                              <v-card>
                                <v-data-table
                                  v-show="skill.levels.length > 0"
                                  :headers="levelHeaders"
                                  :items="skill.levels"
                                  hide-default-footer
                                  dense
                                >
                                  <template v-slot:item="levelProps">
                                    <tr :class="{active: levelProps.item.level === skill.rating}">
                                      <td class="text-right">{{ levelProps.item.level }}</td>
                                      <td class="text-justify py-2">{{ levelProps.item.description }}</td>
                                    </tr>
                                  </template>
                                </v-data-table>
                              </v-card>
                            </v-menu>                            
                          </span>
                        </v-row>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <span 
          v-show="!formValid"
          class="red--text"
        > *Please at least select a job description </span>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      position: {
        type: Object,
        required: true,
      },
      gradeId: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        search: '',
        dialog: null,
        formValid: true,
        progressing: false,
        loading: false,
        loadingTags: false,
        tags: [],
        tagFilterIds: [],
        jobDescriptions: [],
        jobRequirements: [],
        grades: [],
        selectedJobDescription: [],
        selectedJobDescriptionSkill: [],
        selectedRank: null,
        headers: [
          {
            text: 'Description',
            align: 'left',
            sortable: false,
            value: 'value',
          },
          {
            text: 'Skills',
            align: 'left',
            sortable: false,
            value: '',
          },
        ],
        levelHeaders: [
          {
            text: 'Level',
            value: 'level',
            sortable: false, 
          },
          { 
            text: 'Description', 
            align: 'left', 
            value: 'description',
            sortable: false, 
          },
        ],
      }
    },
    computed: {
      validGrades () {
        return this.grades.filter(grade => grade.pivot.id !== this.gradeId)
      },
      selectedJobRequirements () {
        return this.jobRequirements.filter(requirement => {
          return requirement.position_category_rank_id === this.selectedRank
        })
      },
      existingJobRequirements () {
        return this.jobRequirements.filter(requirement => {
          return requirement.position_category_rank_id === this.gradeId
        })
      },
      validJobDescriptions () {
        return this.jobDescriptions.filter(jobDescription => {
          // get job descriptions with more than 1 skill
          if ((jobDescription.skills || []).length <= 0) return false

          // get job descriptions that are not already created
          if (this.existingJobRequirements.length > 0) {
            let existingIds = this.existingJobRequirements.map(requirement => {
              return requirement.job_requirement.job_description_id
            })

            return !existingIds.includes(jobDescription.id)
          }

          return true
        })
      },            
      filteredJobDescriptions () {
        return this.validJobDescriptions.filter(jobDescription => {
          // get job descriptions that match the tags filter 
          if (this.tagFilterIds.length > 0) {
            let tagIds = jobDescription.tags.map(tag => tag.id)

            return _.intersection(this.tagFilterIds, tagIds).length > 0
          }    
          
          return true
        })
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadData()
        } else {
          this.$resetData()
        }
      },
      selectedJobDescription: function (value) {
        if (value.length > 0) {
          this.formValid = true
        }
      },
    },
    methods: {
      submitForm () {
        if (this.selectedJobDescription.length <= 0) {
          this.formValid = false
          return
        }

        this.progressing = true
        
        this.$api.positionJobRequirements().create(this.prepareFormData())
          .then(response => {
            this.$emit('created')
            this.$snack({ message: response.data.status })

            this.dialog = false
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
      loadData () {
        this.loading = true
  
        Promise.all([
          this.$api.jobDescriptions().list(['tags', 'skills.levels']),
          this.$api.tags().list(),
          this.$api.grades().list(this.position.position_category_id),
        ])      
          .then(([descriptions, tags, grades]) => {
            this.jobDescriptions = this.addRatingToSkills(descriptions.data)
            this.tags = tags.data
            this.grades = grades.data

            this.$api.positionJobRequirements().list(this.position.id)
              .then(response => {
                this.jobRequirements = response.data
              })
              .catch(() => {})
              .then(() => {
                this.loading = false
              })          
          })
      },
      // filter (value, search, item) {
      //   const upperCaseSearch = search.toUpperCase()

      //   return value != null &&
      //     search != null &&
      //     typeof value === 'string' &&
      //     (value.toString().toUpperCase().indexOf(upperCaseSearch) !== -1 ||
      //     item.tags.find(tag => tag.name.toString().toUpperCase().indexOf(upperCaseSearch) !== -1) !== undefined)
      // },
      copyRequirements () {
        this.resetFilter()
        this.resetSelected()

        this.selectedJobRequirements.map(requirement => {
          const found = this.validJobDescriptions.find(description => description.id === requirement.job_requirement.job_description_id)
        
          if (!found) return 
        
          let skill = found.skills.find(skill => skill.id === requirement.skill_level.skill_id)
          skill.rating = requirement.skill_level.level

          const existed = this.selectedJobDescription.find(description => description.id === found.id)
          if (!existed) this.selectedJobDescription.push(found)
        })
      },
      resetSelected () {      
        this.selectedJobDescription.splice(0, this.selectedJobDescription.length)

        this.validJobDescriptions.map(description => {
          description.skills.map(skill => {
            skill.rating = 1
          })
        })
      },
      filter (ids) {
        this.resetFilter()
        this.tagFilterIds = ids
      },
      resetFilter () {
        this.tagFilterIds.splice(0, this.tagFilterIds.length)
      },

      addRatingToSkills (data) {
        let copy = [...data]

        copy.map(item => {
          item.skills.map(skill => {
            skill.rating = 1
          })
        })

        return copy
      },
      prepareFormData () {
        let data = []

        this.selectedJobDescription.map(description => {
          description.skills.map(skill => {
            let levelId = skill.levels[skill.rating - 1].id
          
            data.push({
              position_id: this.position.id,
              position_category_rank_id: this.gradeId,
              job_description_skill_id: skill.pivot.id,
              skill_level_id: levelId,
            })
          })        
        })

        return data
      },    
    },
  }
</script>

<style lang="css" scoped>
.overflow {
  height:65vh;
}

::v-deep .v-rating .v-icon{
  padding:0px;
}

::v-deep .v-rating {
  width:80px;
}

.v-menu {
  display: block;
}

.horizontal-scroll-xl{
  overflow-x:hidden; 
  overflow-y:hidden; 
  width:20vw;
}
</style>
